import { defineComponent, ref, // watch,
computed } from "vue";
export default defineComponent({
    components: {},
    props: {
        config: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var inputValue = ref("");
        var selectValue = ref("");
        var selected = computed({
            get: function() {
                return props.model[props.config.field.selectProp];
            },
            set: function(val) {
                emit("update-field", {
                    prop: props.config.field.selectProp,
                    value: val
                });
            }
        });
        var inputed = computed({
            get: function() {
                return props.model[props.config.prop];
            },
            set: function(val) {
                emit("update-field", {
                    prop: props.config.prop,
                    value: val
                });
            }
        });
        return {
            inputValue: inputValue,
            selectValue: selectValue,
            selected: selected,
            inputed: inputed
        };
    }
});
